import { render, staticRenderFns } from "./categoriesT2.vue?vue&type=template&id=0051b0f3"
import script from "./categoriesT2.vue?vue&type=script&lang=js"
export * from "./categoriesT2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports